import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OpenIdService } from '../service/open-id.service';
import { RoleGuard } from './role.guard';

@Injectable({
    providedIn: 'root',
})
export class OperatorRoleGuard extends RoleGuard {
    public requireRole = 'barter-ledger-operator';
    constructor(openIdService: OpenIdService, router: Router) {
        super(openIdService, router);
    }
}
